import type { Maybe } from './types';
import type { GetUserStatsQuery } from '@/graphql/queries/GetUserStats.query';

import { GetUserStatsDocument } from '@/graphql/queries/GetUserStats.query';
import { paToParentIDMap } from '@/helpers/tracking/util/paParentMapping';
import { getQuery } from '@/helpers/request-helper';
import { getAxiosCached } from './axios-helper';
import { getAppVersion } from '@/graphql/utils/links';
import { generateToken } from '@/helpers/user-helper';

/**
 * This here only fetches the user audiences for the Audience Refresh
 * currently done in `getAudienceContext` of TrackingHelper.
 */
export async function fetchUserAudiences(jwId?: string, accessToken?: string) {
	let freshToken: Maybe<string> = accessToken;
	try {
		if (accessToken != null) freshToken = await generateToken(accessToken, jwId);
	} catch {
		freshToken = undefined;
	}

	const headers: Record<string, string> = {
		'content-type': 'application/json',
		'App-Version': getAppVersion(),
	};

	if (import.meta.client) {
		if (jwId) headers['Device-Id'] = jwId;
		if (freshToken) headers.Authorization = `Bearer ${freshToken}`;
	}

	const { data: response } = await getAxiosCached().request({
		method: 'POST',
		url: JW_CONFIG.GRAPHQL_URL,
		headers,
		data: { query: getQuery(GetUserStatsDocument) },
	});

	const data: GetUserStatsQuery | null = response?.data ?? null;

	const permanentAudiences = data?.stats.permanentAudiences ?? [];
	const parentPermanentAudiences = permanentAudiences
		.map(audienceID => audienceID.split('pa:')?.[1] || '')
		.flatMap(audienceID => (paToParentIDMap[audienceID] || []).map(pa => `pa:${pa.listId}`));

	return {
		permanentAudiences,
		parentPermanentAudiences,
	};
}
